import { useQuery } from "react-query";
import { planApi } from "@/react/api";

export interface UseFetchEmailHubPlanProps {
  billingCurrency?: string;
  isEnabled?: boolean;
  locale?: string;
}

export const useFetchEmailHubPlan = ({
  billingCurrency = "",
  locale = "",
  isEnabled = true,
}: UseFetchEmailHubPlanProps) => {
  const {
    data: emailHubPlan,
    isLoading: isEmailHubPlanLoading,
    error: errorFetchingEmailHubPlan,
  } = useQuery(
    ["plan", "fetch", "email_hub", billingCurrency, locale],
    () =>
      planApi.fetchEmailHubPlan({
        billing_currency: billingCurrency,
        locale: locale,
      }),
    {
      enabled: isEnabled,
    },
  );

  return {
    emailHubPlan,
    isEmailHubPlanLoading,
    errorFetchingEmailHubPlan,
  };
};
